/** @format */

import {useState} from 'react';

import {useTheme} from '@mui/material/styles';

import {FormControl, MenuItem} from '@mui/material';

import {Trans} from 'react-i18next';

import PrimarySmallButton from 'components/buttons/PrimarySmallButton';

import {
  Actions,
  Divider,
  Multiply,
  Row,
  StyledInputLabel,
  StyledPopover,
  StyledSelect,
  Title,
  getSelectMenuListSx,
  getSelectMenuPaperSx,
} from './styles';

type Option = {id: number | string; name: string};

interface Props {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  options: Option[];
  onConfirm: (aId: string, bId: string) => void;
}

const CrSelectPopover = ({anchorEl, open, onClose, options, onConfirm}: Props) => {
  const theme = useTheme();
  const [firstChosenId, setFirstChosenId] = useState<string>('');
  const [secondChosenId, setSecondChosenId] = useState<string>('');

  const handleConfirm = () => {
    if (firstChosenId !== '' && secondChosenId !== '') {
      onConfirm?.(firstChosenId, secondChosenId);
      onClose();
    }
  };

  return (
    <StyledPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
    >
      <Title variant='h6' sx={{ml: 2, mb: 6}}>
        <Trans>Выбрать показатели</Trans>
      </Title>
      <Row>
        <FormControl fullWidth>
          <StyledInputLabel id='cr-a-label'>
            <Trans>Первый показатель</Trans>
          </StyledInputLabel>
          <StyledSelect
            labelId='cr-a-label'
            value={firstChosenId}
            size='small'
            variant='outlined'
            label='Первый показатель'
            onChange={e => {
              const newFirst = String(e.target.value);
              setFirstChosenId(newFirst);
              setSecondChosenId(prev => (prev === newFirst ? '' : prev));
            }}
            MenuProps={{
              PaperProps: {sx: getSelectMenuPaperSx(theme)},
              MenuListProps: {sx: getSelectMenuListSx(theme)},
            }}
          >
            {options
              .filter(opt => String(opt.id) !== secondChosenId)
              .map(opt => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.name}
                </MenuItem>
              ))}
          </StyledSelect>
        </FormControl>
        <Divider>÷</Divider>
        <FormControl fullWidth>
          <StyledInputLabel id='cr-b-label'>
            <Trans>Второй показатель</Trans>
          </StyledInputLabel>
          <StyledSelect
            size='small'
            labelId='cr-b-label'
            value={secondChosenId}
            label='Второй показатель'
            onChange={e => setSecondChosenId(String(e.target.value))}
            MenuProps={{
              PaperProps: {sx: getSelectMenuPaperSx(theme)},
              MenuListProps: {sx: getSelectMenuListSx(theme)},
            }}
          >
            {options
              .filter(opt => String(opt.id) !== firstChosenId)
              .map(opt => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.name}
                </MenuItem>
              ))}
          </StyledSelect>
        </FormControl>
        <Multiply>× 100%</Multiply>
      </Row>
      <Actions>
        <PrimarySmallButton
          onClick={handleConfirm}
          disabled={
            firstChosenId === '' || secondChosenId === '' || firstChosenId === secondChosenId
          }
        >
          <Trans>Подтвердить</Trans>
        </PrimarySmallButton>
      </Actions>
    </StyledPopover>
  );
};

export default CrSelectPopover;
